import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import noop from 'lodash/noop';
import { useState, useRef, useCallback, useEffect } from 'react'; // The hook that manages the scroll position logic and provides scroll control functions

var useScrollState = function useScrollState(scrollableElement) {
  var scrollStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

  var _useState = useState('none'),
      _useState2 = _slicedToArray(_useState, 2),
      scrollPosition = _useState2[0],
      setScrollPosition = _useState2[1];

  var scrollAnimationFrame = useRef(null);
  var updateScrollState = useCallback(function () {
    if (!scrollableElement) {
      return;
    }

    var scrollLeft = scrollableElement.scrollLeft,
        scrollWidth = scrollableElement.scrollWidth,
        clientWidth = scrollableElement.clientWidth;

    if (scrollWidth <= clientWidth) {
      setScrollPosition('none');
    } else if (scrollLeft === 0) {
      setScrollPosition('start');
    } else if (scrollLeft + clientWidth >= scrollWidth) {
      setScrollPosition('end');
    } else {
      setScrollPosition('intermediate');
    }
  }, [scrollableElement]);
  var handleScroll = useCallback(function () {
    if (scrollAnimationFrame.current !== null) {
      cancelAnimationFrame(scrollAnimationFrame.current);
    }

    scrollAnimationFrame.current = requestAnimationFrame(updateScrollState);
  }, [updateScrollState]);
  var scrollLeft = useCallback(function () {
    if (!scrollableElement) {
      return;
    }

    scrollableElement.scrollBy({
      left: -scrollStep,
      behavior: 'smooth'
    });
  }, [scrollStep, scrollableElement]);
  var scrollRight = useCallback(function () {
    if (!scrollableElement) {
      return;
    }

    scrollableElement.scrollBy({
      left: scrollStep,
      behavior: 'smooth'
    });
  }, [scrollStep, scrollableElement]);
  useEffect(function () {
    if (!scrollableElement) {
      return noop;
    }

    var handleFocusIn = function handleFocusIn(event) {
      var target = event.target;

      if (target instanceof HTMLElement && scrollableElement.contains(target)) {
        target.scrollIntoView({
          behavior: 'smooth',
          inline: 'nearest'
        });
      }
    };

    scrollableElement.addEventListener('focusin', handleFocusIn);
    scrollableElement.addEventListener('scroll', handleScroll);
    updateScrollState();
    return function () {
      scrollableElement.removeEventListener('focusin', handleFocusIn);
      scrollableElement.removeEventListener('scroll', handleScroll);

      if (scrollAnimationFrame.current !== null) {
        cancelAnimationFrame(scrollAnimationFrame.current);
      }
    };
  }, [scrollableElement, handleScroll, updateScrollState]);
  return {
    scrollPosition: scrollPosition,
    scrollLeft: scrollLeft,
    scrollRight: scrollRight
  };
};

export { useScrollState };